import { forwardRef } from 'react'
import type { IconProps } from '../icon-props'
import { Icon } from '../icon'
/** @preview ![icon](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ3aGl0ZSIvPjxwYXRoIGZpbGw9IiMxMTE5MjgiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0ibTExIDE5LTctNyA3LTcgMS40MiAxLjQyTDcuODMgMTFIMjB2Mkg3LjgzbDQuNTggNC41OXoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==) */
export const IconArrowLeft = forwardRef<SVGElement, IconProps>((props, ref) => (
    <Icon ref={ref} {...props}>
        <path
            fill="#111928"
            fillRule="evenodd"
            d="m11 19-7-7 7-7 1.42 1.42L7.83 11H20v2H7.83l4.58 4.59z"
            clipRule="evenodd"
        />
    </Icon>
))
IconArrowLeft.displayName = 'IconArrowLeft'
